/**
 * Asynchronously loads the component for InventoryDetailsPage
 */

import { lazyLoad } from 'utils/loadable';

export const InventoryDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.InventoryDetailsPage,
);
